import { Container } from "react-grid-system";
import LiveFooterMenu from "./LiveFooterMenu";
import LiveMenu from "./LiveMenu";
import LiveSubmenu from "./LiveSubmenu";

const LivePage = ({ children }) => {
  return (
    <Container fluid>
      <LiveMenu />
      <LiveSubmenu />
      <LiveFooterMenu />
      {children}
    </Container>
  );
};

export default LivePage;
